export enum SubscriptionStatusEnum {
  ACTIVE,
  EXPIRED,
  DISABLED,
  NOT_FOUND,
  ERROR,
}
